import {httpMonitorAPI} from 'features/http/api/httpMonitorAPI';
import {useUpdateMonitorTags} from 'entities/monitor';

export const useUpdateHttpMonitorTags = (uuid: string | undefined) => {
    const [updateHttpMonitor] = httpMonitorAPI.useUpdateHttpMonitorMutation();

    return useUpdateMonitorTags(updateHttpMonitor, uuid);
};

export default useUpdateHttpMonitorTags;
